import moment from "moment";
export const errorHandling = (fn, args) => {
    let result;
    try {
        result = args ? fn(...args) : fn();
    } catch (error) {
        console.error(error)
    }
    return result;
}
export function isEdit(ori, current) {
    for (let i = 0; i < Object.keys(ori).length; i += 1) {
        for (let j = 0; j < Object.keys(current).length; j += 1) {
            const orikey = Object.keys(ori)[i]
            const currentkey = Object.keys(current)[j]
            if (orikey === currentkey) {
                let value = ''
                // 数字类型转0
                if (typeof (ori[orikey]) === 'number') {
                    value = ori[orikey] || 0
                } else {
                    // null转空串
                    value = ori[orikey] || ''
                }
                if (value !== current[currentkey]) {
                    console.log(ori[orikey], current[currentkey])
                    return true
                }
            }
        }
    }
    return false
}
//配合async/await使用
export function sleep(time) {
    return new Promise((resolve, reject) => {
        setTimeout(resolve, time);
    });
}
async function test(params) {
    console.info("开始");
    await sleep(3000)
    console.info("结束");
}

export const isEmpty = function (val) {
    // null or undefined
    if (val == null) return true;

    if (typeof val === 'boolean') return val;

    if (typeof val === 'number') return !val;

    switch (Object.prototype.toString.call(val)) {
        // String or Array
        case '[object String]':
        case '[object Array]':
            return !val.length;

        // Map or Set or File
        case '[object File]':
        case '[object Map]':
        case '[object Set]': {
            return !val.size;
        }
        // Plain Object
        case '[object Object]': {
            return !Object.keys(val).length;
        }
    }

    return false;
};

export const checkPro = () => {
    const protocol = location.protocol;
    const res = protocol.includes("https") ? "wss://" : "ws://"
    return res
}

//增加语音阅读功能
// https://www.jianshu.com/p/8044b70308a6
export const speaker = (msg) => {
    const voices = window.speechSynthesis.getVoices();
    const ssu = new SpeechSynthesisUtterance()
    ssu.volume = 1// 设置音量 0-1
    ssu.text = msg // 设置语音内容
    speechSynthesis.speak(ssu) // 播放语音
}
export function debounce(fn, delay) {
    let timer;
    return function (...args) {
        if (timer) {
            clearTimeout(timer)
        }
        timer = setTimeout(() => {
            fn.apply(this, args);
        }, delay);
    }
}
export function throttle(fn, delay) {
    let timer;
    return function () {
        if (timer) {
            return
        }
        timer = setTimeout(() => {
            fn.apply(this, arguments);
            timer = null
        }, delay);
    }
}
export const on = function (element, event, handler) {
    if (document.addEventListener) {
        if (element && event && handler) {
            element.addEventListener(event, handler, false);
        };
    } else {
        if (element && event && handler) {
            element.attachEvent('on' + event, handler);
        };
    }
}

// 关闭监听事件
export const off = (function () {
    // 如果使用闭包的形式,要使用立即执行,不然访问到的element为undefined
    if (document.removeEventListener) {
        return function (element, event, handler) {
            if (element && event) {
                element.removeEventListener(event, handler, false);
            }
        };
    } else {
        return function (element, event, handler) {
            if (element && event) {
                element.detachEvent('on' + event, handler);
            }
        };
    }
})();

export function directDownload(url, filename) {
    let xhr = new XMLHttpRequest();
    xhr.open("GET", url, true);
    xhr.responseType = "blob";
    xhr.onload = e => {
        downloadFile(xhr, filename)
    };
    xhr.send();
}

export function downloadFile(res, filename) {
    // const blob = new Blob([res.data,], {
    //     type: "application/excel;charset=UTF-8" //表示下载文档为pdf，如果是word则设置为msword，excel为excel
    // })
    // const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    const url = window.URL.createObjectURL(res.data || res.response);
    a.style.display = 'none'
    a.href = url;
    a.download = filename;
    document.body.appendChild(a)
    a.click();
    document.body.removeChild(a)
    window.URL.revokeObjectURL(url);
}
/**
* 参数处理
* @param {*} params  参数
*/
export function transParams(params) {
    let result = ''
    for (const propName of Object.keys(params)) {
        const value = params[propName];
        var part = encodeURIComponent(propName) + "=";
        if (value !== null && value !== "" && typeof (value) !== "undefined") {
            if (typeof value === 'object') {
                for (const key of Object.keys(value)) {
                    if (value[key] !== null && value[key] !== "" && typeof (value[key]) !== 'undefined') {
                        let params = propName + '[' + key + ']';
                        var subPart = encodeURIComponent(params) + "=";
                        result += subPart + encodeURIComponent(value[key]) + "&";
                    }
                }
            } else {
                result += part + encodeURIComponent(value) + "&";
            }
        }
    }
    return result
}
export function isJSON(str) {
    if (typeof str === "string") {
        try {
            var obj = JSON.parse(str);
            if (typeof obj == 'object' && obj) {
                return true;
            } else {
                return false;
            }
        } catch (error) {
            return false;
        }
    }
    return false;
}

export function treeFind(tree, fn) {
    for (const item of tree) {
        if (fn(item)) {
            return item;
        }
        if (item.children) {
            const res = treeFind(item.children, fn);
            if (res) return res;
        }
    }
}
//树结构转列表
export function treeToList(tree, result = [], level = 0, children = "children") {
    tree.forEach(node => {
        result.push(node)
        node.level = level + 1;
        node[children] && treeToList(node[children], result, level + 1, children)
    })
    return result
}
//树结构筛选
export function treeFilter(tree, children = "children", func) {
    // 使用map复制一下节点，避免修改到原树
    return tree.map(node => ({ ...node })).filter(node => {
        node[children] && (node[children] = treeFilter(node[children], children, func))
        return func(node) || (node[children] && node[children].length)
    })
}

export function getDateTime(date = 'day') {
    let startTime, endTime;
    switch (date) {
        case "week":
            startTime = moment().startOf("week").add(1, "days").format("YYYY-MM-DD HH:mm:ss");
            endTime = moment().endOf("week").add(1, "days").format("YYYY-MM-DD HH:mm:ss");
            break;
        default:
            startTime = moment().startOf(date).format("YYYY-MM-DD HH:mm:ss");
            endTime = moment().endOf(date).format("YYYY-MM-DD HH:mm:ss");
            break;
    }

    return [
        startTime,
        endTime,
    ];
}
